<template>
  <div>
    <b-modal
      id="ModalRelatorio"
      header-class="modal-cabecalho"
      no-close-on-backdrop
      no-close-on-esc
    >
      <LoadingPadraoContainer
        v-if="loadingPdf"
        class="loading-padrao-backdrop"
        background
        :fraseLoading="['Gerando relatório', 'Aguarde um momento']"
        delay="5000"
        classe="azul"
      />
      <Header
        mini
        titulo="Relatório do Histórico de Alterações"
        icone="file-download"
        cor="azul"
        slot="modal-header"
      />
      <div v-if="blOptions">
        <div class="subtitulo-modal">
          <h5>Selecione a opção de Gerar Relatório em PDF ou Excel</h5>
        </div>
        <div class="botoes-box">
          <div @click="pdfSelected" class="icone">
            <button>
              <img src="../../assets/images/images/PDF.svg" />
            </button>
          </div>
          <div @click="impressaoExcel" class="icone">
            <button>
              <img src="../../assets/images/images/xlsx.svg" />
            </button>
          </div>
        </div>
      </div>
      <!-- <BotaoPadrao
      v-if="blPdf"
          arredondadoEsquerda
          nome="Voltar"
          icone="arrow-left"
          :click="OptionsSelected"
          cor="azul"
        /> -->
      <ModalRelatorioPdf
        :alteracoes="alteracoes"
        @produtosFiltradosAtualizados="atualizarProdutosFiltrados"
        @filtrosUtilizados="atualizarFiltros"
        :form="form"
        :voltar="blVoltar"
        :blOptions="blOptions"
        v-show="blPdf"
      ></ModalRelatorioPdf>

      <template slot="modal-footer">
        <BotaoPadrao
          v-if="blPdf"
          arredondadoEsquerda
          class="botao-padding"
          nome="Voltar"
          icone="arrow-left"
          :click="voltarSelected"
          cor="azul"
        />
        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="Cancelar"
          icone="times"
          :click="closeModal"
        />

        <BotaoPadrao
          v-show="blPdf"
          arredondadoEsquerda
          class="botao-padding"
          nome="Gerar Relatório"
          icone="check"
          :click="handleClick"
          :desabilita="blButtonOk"
          cor="verde"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import Api from "@/services/api.js";
import { mapGetters } from "vuex";
import ModalRelatorioPdf from "../ModalRelatorio/ModalRelatorioPdf.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "ModalRelatorio",
  components: {
    CenarioInput,
    BotaoPadrao,
    ModalRelatorioPdf,
    Header,
    LoadingPadraoContainer
  },
  inject: ["pushAlert"],
  data() {
    return {
      blPdf: false,
      blExcel: false,
      blOptions: true,
      blVoltar: false,
      loadingPdf: false,
      blButtonOk: true,
      ano: "",
      semestre: "",
      produtosFiltrados: []
    };
  },
  props: {
    form: {
      type: Object
    },
    alteracoes: {
      type: Array
    }
  },
  watch: {
    produtosFiltrados() {
      if (this.produtosFiltrados.length != 0) {
        this.blButtonOk = false;
      } else {
        this.blButtonOk = true;
      }
    },
    loadingPdf() {
      if (this.loadingPdf == true) {
        this.blButtonOk = true;
      }
    }
  },
  computed: {
    ...mapGetters("empresa", ["getEmpresa"]),
    ...mapGetters("usuario", ["getUsuario"])
  },
  methods: {
    async impressaoExcel(form) {
      this.loadingPdf = true;
      try {
        let formCompleto = {
          ...form,
          empresa: this.getEmpresa.name,
          usuario: this.getUsuario.nome_usuario
        };
        let dados = { filtro: formCompleto, produtos: this.alteracoes };
        const compressedData = Buffer.from(JSON.stringify(dados)).toString("base64");
        // Encode the compressed data in base64 format
        // const base64Data = btoa(compressedData);
        let response = await new Api().downloadFile("Mudanca/obterRelatorioExcel", {
          compressedData
        });
        const blob = new Blob([response], { type: "application/vnd.ms-excel" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "RelatorioRTE.xlsx");
        document.body.appendChild(link);
        this.pushAlert("Relatório gerado com sucesso!", "success");
        this.loadingPdf = false;
        link.click();
      } catch (error) {
        this.loadingPdf = false;
        this.pushAlert("Erro ao gerar relatório!", "danger");
        console.error(error);
      }
    },
    pdfSelected() {
      this.blPdf = true;
      this.blExcel = true;
      this.blOptions = false;
    },
    excelSelected() {
      this.blExcel = true;
      this.blPdf = false;
    },
    voltarSelected() {
      this.blVoltar = true;
      this.blPdf = false;
      this.blExcel = false;
      this.blOptions = true;
    },
    OptionsSelected() {
      this.blPdf = false;
      this.blOptions = true;
    },
    closeModal() {
      this.blPdf = false;
      this.blExcel = false;
      this.blVoltar = false;
      this.blOptions = true;
      this.$root.$emit("bv::hide::modal", "ModalRelatorio");
    },

    atualizarProdutosFiltrados(produtosFiltrados) {
      this.produtosFiltrados = produtosFiltrados;
    },
    atualizarFiltros(filtro) {
      this.ano = filtro.ano;
      this.semestre = filtro.semestre;
    },
    async impressaoPdf(form) {
      this.loadingPdf = true;
      try {
        let formCompleto = {
          ...form,
          empresa: this.getEmpresa.name,
          usuario: this.getUsuario.nome_usuario,
          ano: this.ano,
          semestre: this.semestre
        };
        let dados = { filtro: formCompleto, produtos: this.produtosFiltrados };
        // Compress the data using pako
        const compressedData = Buffer.from(JSON.stringify(dados)).toString("base64");
        // Encode the compressed data in base64 format
        // const base64Data = btoa(compressedData);
        let response = await new Api().downloadFile("Mudanca/obterRelatorioPdf", {
          compressedData
        });
        const blob = new Blob([response], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "RelatórioRTE.pdf");
        document.body.appendChild(link);
        link.click();
        this.pushAlert("Relatório gerado com sucesso!", "success");
      } catch (error) {
        this.pushAlert("Erro ao gerar relatório!", "danger");
        console.error(error);
      }
      this.loadingPdf = false;
    },
    handleClick() {
      this.impressaoPdf(this.form);
    }
  }
};
</script>
<style>
.botoes-box {
  display: flex;
  justify-content: center;
}

.icone {
  margin: 10px 20px;
  position: relative;
}

.icone img {
  width: 70px;
  height: 70px;
  transition: transform 0.3s ease;
}

.icone:hover img {
  transform: scale(1.2);
  cursor: pointer;
}
button:focus img {
  transform: scale(1.2);
  cursor: pointer;
}
.subtitulo-modal {
  text-align: center;
}

.loading-modal {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #9e9e9ea8;
  left: 0;
  top: 0;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  color: var(--branco);
}

h5 {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
}
p {
  font-size: 13px;
}
.total {
  margin: 10px 0;
}
</style>
